import cloneDeep from 'lodash/cloneDeep';

export default {
  namespaced: true,

  state: {
    rooms: [],
    roomTemplates: [],
    objects: [],
    objectTemplates: [],
    objectTemplate: null,
    selectedRoomIndex: 0,
    totalCubicMetres: 0,
  },

  getters: {
    rooms: (state) => state.rooms,
    roomTemplates: (state) => state.roomTemplates,
    objects: (state) => state.rooms?.map((room) => room.objects).flat(),
    totalCubicMetres: (state) => {
      if (!state.rooms.length) {
        return 0;
      }

      const objects = state.rooms.map((room) => room.objects).flat();

      return objects.reduce((acc, object) => acc + object.properties.size * object.count, 0);
    },
    objectTemplates: (state) => state.objectTemplates,
    objectTemplate: (state) => state.objectTemplate,
    selectedRoomIndex: (state) => state.selectedRoomIndex,
    selectedRoom: (state) => {
      if (typeof state.rooms[state.selectedRoomIndex] === 'undefined') {
        return null;
      }

      return state.rooms[state.selectedRoomIndex];
    },
  },

  actions: {
    //
  },

  mutations: {
    hydrate(state, obj) {
      if (!state.rooms.length) {
        state.rooms = JSON.parse(obj.predefinedRooms);
      }

      state.roomTemplates = JSON.parse(obj.roomTemplates);
      state.objectTemplates = JSON.parse(obj.objectTemplates);
      state.objectTemplate = JSON.parse(obj.objectTemplate);
    },

    setSelectedRoomIndex(state, index) {
      state.selectedRoomIndex = index;
    },

    updateRoomField(state, [selectedRoom, name, value]) {
      selectedRoom[name] = value;
    },

    updateObjectField(state, [object, name, value]) {
      object[name] = value;
    },

    updateObjectCountField(state, [object, value]) {
      if (value === 'decrement') {
        object.count -= 1; return;
      }

      if (value === 'increment') {
        object.count += 1; return;
      }

      object.count = value;
    },

    addRoom(state, roomTemplate) {
      state.rooms.push({ ...roomTemplate });
    },

    removeRoom(state, index) {
      // eslint-disable-next-line no-alert
      if (window.confirm('Weet je zeker dat je deze kamer wilt verwijderen?')) {
        // Remove room from intake
        state.rooms.splice(index, 1);

        if (state.rooms.length && index === state.selectedRoomIndex) {
          state.selectedRoomIndex = 0;
          state.selectedRoom = state.intake[state.selectedRoomIndex];
        }
      }
    },

    addObjectToRoom(state, [objectId, room]) {
      // Create a clone of the base object template
      const objectTemplate = cloneDeep(state.objectTemplate);

      if (objectId === '') {
        room.objects.push(objectTemplate);

        return;
      }

      const selectedObject = state.objectTemplates.filter((roomObject) => roomObject.id === objectId)[0];

      if (!selectedObject) return;

      // Overwrite properties with properties from the object we selected
      objectTemplate.properties = Object.assign(objectTemplate.properties, selectedObject, {
        size: selectedObject.size,
        montageMinutes: selectedObject.assembly_time,
      });

      // Overwrite the title
      objectTemplate.object_id = selectedObject.id;
      objectTemplate.title = selectedObject.name;

      room.objects.push(objectTemplate);
    },

    removeObjectFromRoom(state, [selectedRoom, index]) {
      selectedRoom.objects.splice(index, 1);
    },

    addFilesToRoom(state, [selectedRoom, files]) {
      selectedRoom.media = files;
    },

    removeFileFromRoom(state, [selectedRoom, index]) {
      selectedRoom.media.splice(index, 1);
    },
  },
};
